import { DataBean } from "../DataBean";

export class ViewForEmployee extends DataBean {


    public async getViewForEmployeeFactorsConsolidated(year:any,accountID:any,valueType:any,fortnightType:any,factorName:any,idAppointment:any,idEntailment:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "String_getViewForEmployeeFactorsConsolidated_Number_Number_Number_Number_String_Number_Number_Number_Number", [year,accountID,valueType,fortnightType,factorName,idAppointment,idEntailment,page,recordsPerPage]);
    }

 
}